import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { useSubmenuCollapse } from 'src/hooks/use-submenu-collapse';

type PageContainerProps = BoxProps & {
  children: ReactNode;
};

export const PageContainer = ({ children, sx, ...props }: PageContainerProps) => {
  return (
    <Box
      sx={{
        ml: { xs: 0, lg: '70px' },
        width: { lg: 'calc(100% - 70px)', xs: '100%' },
        p: { xs: '0 20px', md: '0 30px' },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const SubNavPageContainer = ({ children, sx, ...props }: PageContainerProps) => {
  // Offset shrinks to the icon bar width when the submenu panel is collapsed
  const { isSubmenuCollapsed } = useSubmenuCollapse();
  const sidebarWidth = isSubmenuCollapsed ? '70px' : '315px';

  return (
    <Box
      sx={{
        ml: { xs: 0, lg: sidebarWidth },
        width: { lg: `calc(100% - ${sidebarWidth})`, xs: '100%' },
        p: { xs: '0 20px 20px', md: '0 30px 30px' },
        transition: 'margin-left 0.2s ease-in-out, width 0.2s ease-in-out',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
